

export const skills = {
  Web: [
    { name: "React", percent: 100 ,image: require("./image/yatrapic.png")},
    { name: "ES-6", percent: 100 },
    { name: "Node JS", percent: 100 },
    { name: "Express JS", percent: 100 },
    { name: "MongoDB", percent: 100 },

  ],
  Others: [
    { name: "Redux", percent: 100 },
    { name: "Jest", percent: 100 },
  ],
  Programming: [
    { name: "JavaScript", percent: 100 },
  ],
  Tools: [
    { name: "Git", percent: 100 },
    { name: "Postman", percent: 100 },
    { name: "MongoDB Atlas", percent: 100 },
    { name: "Vercel", percent: 100 },
    { name: "Heroku", percent: 100 },
  ],
}
